const translations = require('../translations');
const quickRelease = require('./quickRelease');
const bookingForm = require('./bookingForm');
const orderSummary = require('./orderSummary');
const bookingBasket = require('./bookingBasket');
const constants = require('../utils/constants');
const dayjs = require("dayjs");

require('dayjs/locale/fr');
require('dayjs/locale/en');
require('dayjs/locale/de');

const TODAY = dayjs().format("YYYY-MM-DD");
const INITIAL_YEAR = dayjs().format("YYYY");
const INITIAL_MONTH = dayjs().format("M");
const OFF_SEASON_SLOTS = JSON.parse(document.getElementById('off-season-data').dataset.slots);

let QUICK_RELEASE_DATA = null;
let NUMBER_OF_PASSENGERS = 1;
let LANGUAGE = 'fr';
let CALENDAR_ELEMENT = null;

let selectedMonth = dayjs(new Date(INITIAL_YEAR, INITIAL_MONTH - 1, 1));
let currentMonthDays;
let previousMonthDays;
let nextMonthDays;

const AREAS = {
    yUvqaIOWo75OYQoTJG64: 'FB',
    eN48VsrzsBfO5klfhV3m: 'CH'
}

const updateQuickReleaseData = () => {
    CALENDAR_ELEMENT.classList.add('loading');
    quickRelease.fetchData()
        .then((quickReleaseData) => {
            QUICK_RELEASE_DATA = quickReleaseData;
            updateCalendar(CALENDAR_ELEMENT.dataset.currentYear, CALENDAR_ELEMENT.dataset.currentMonth);
            CALENDAR_ELEMENT.classList.remove('loading');
        });
}

const buildCalendar = (elementID) => {
    if (elementID) {
        const language = document.getElementsByTagName('html')[0].attributes.lang.value;
        language !== 'fr' ? LANGUAGE = language : false;
        dayjs.locale(language);

        let numberOfPassengers = 1;
        let currentYear = INITIAL_YEAR;
        let currentMonth = INITIAL_MONTH;

        if (constants.existingReservation !== false) {
            numberOfPassengers = constants.reservation.numberOfPassengers;
            updateNumberOfPassengers(numberOfPassengers);

            currentYear = constants.reservation.year;
            currentMonth = constants.reservation.month;
            selectedMonth = dayjs(new Date(currentYear, currentMonth-1, 1));
        }

        document.getElementById(elementID).innerHTML = `
            <input type="hidden" value="` + numberOfPassengers + `" id="number-of-passengers-value"/>
            <div class="calendar-month loading" id="calendar-month" data-current-month="` + currentMonth + `" data-current-year="` + currentYear + `">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
              <div class="calendar-month-header">
                <div id="selected-month" class="calendar-month-header-selected-month" ></div>
                <div class="calendar-month-header-selectors">
                  <span id="previous-month-selector"><</span>
                  <span id="present-month-selector">` + translations.TODAY_STRING + `</span>
                  <span id="next-month-selector">></span>
                </div>
              </div>

              <ol id="days-of-week" class="day-of-week"/></ol>
              <ol id="calendar-days" class="days-grid"></ol>

              <div class="calendar-available-slots" id="calendar-available-slots">
                <div id="close-available-slots"></div>
                <div id="slots-selected-date"></div>
                <div id="slots-wrapper"></div>
              </div>
            </div>

            <div class="legends">
                <div class="legend-row">
                    <div class="legend today" id="legend-today"><span class="color"></span>` + translations.LEGENDS.today + `</div>
                    <div class="legend available" id="legend-available"><span class="color"></span>` + translations.LEGENDS.available + `</div>
                    <div class="legend full-closed" id="legend-full-closed"><span class="color"></span>` + translations.LEGENDS.fullClosed + `</div>
                    <div class="legend off-season" id="legend-off-season"><span class="color"></span>` + translations.LEGENDS.offSeason + `</div>
                    <div class="area ch">
                        <span class="picto">VM</span>
                        <div class="name-description">
                            <span>` + translations.SLOTS.flightType.mountainFlight + `</span>
                            <span>(` + translations.SLOTS.flightType.mountainFlightDescription + `)</span>
                        </div>
                    </div>
                    <div class="area fb">
                        <span class="picto">VS</span>
                        <div class="name-description">
                            <span>` + translations.SLOTS.flightType.lowlandFlight + `</span>
                            <span>(` + translations.SLOTS.flightType.lowlandFlightDescription + `)</span>
                        </div>
                    </div>
                </div>
            </div>
        `;

        CALENDAR_ELEMENT = document.getElementById('calendar-month');

        const daysOfWeekElement = document.getElementById("days-of-week");
        translations.WEEKDAYS.forEach((weekday) => {
            const weekDayElement = document.createElement("li");
            daysOfWeekElement.appendChild(weekDayElement);
            weekDayElement.innerText = weekday;
        });

        initMonthSelectors();
        initSlotsModalClose();
        updateQuickReleaseData();

        if (constants.existingReservation) {
            selectSlot(
                constants.reservation.flightData,
                dayjs(constants.reservation.datetime).format('H') < 15 ? 'mountainFlight' : 'lowlandFlight'
            );
        }

        return CALENDAR_ELEMENT;
    } else {
        console.error('Please provide HTML element ID attribute value to build calendar');
    }
}

const updateCalendar = (year = INITIAL_YEAR, month = INITIAL_MONTH) => {
    const calendarDaysElements = document.getElementById("calendar-days");
    document.getElementById("selected-month").innerText = dayjs(
        new Date(year, month - 1)
    ).format("MMMM YYYY");

    removeAllDaysElements(calendarDaysElements);

    currentMonthDays = createDaysForCurrentMonth(
        year,
        month,
        dayjs(`${year}-${month}-01`).daysInMonth()
    );
    previousMonthDays = createDaysForPreviousMonth(year, month);
    nextMonthDays = createDaysForNextMonth(year, month);

    const days = [...previousMonthDays, ...currentMonthDays, ...nextMonthDays];

    const currentDate = dayjs();
    const hoursBeforeBooking = JSON.parse(document.getElementById('hours-before-booking').dataset.hoursBeforeBooking);
    const minimalBookingDate = currentDate.add(hoursBeforeBooking, 'hour');

    days.forEach((day) => {
        appendDay(day, calendarDaysElements, minimalBookingDate);
    });

    CALENDAR_ELEMENT.classList.remove('loading');
}

const createDaysForCurrentMonth = (year, month) => {
    return [...Array(getNumberOfDaysInMonth(year, month))].map((day, index) => {
        return {
            date: dayjs(`${year}-${month}-${index + 1}`).format("YYYY-MM-DD"),
            dayOfMonth: index + 1,
            isCurrentMonth: true
        };
    });
}

const createDaysForPreviousMonth = (year, month) => {
    let firstDayOfTheMonthWeekday = getWeekDay(currentMonthDays[0].date);
    const previousMonth = dayjs(`${year}-${month}-01`).subtract(1, "month");

    const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday;
    const previousMonthLastMondayDayOfMonth = dayjs(currentMonthDays[0].date)
        .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
        .date();

    return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${previousMonth.year()}-${previousMonth.month() + 1}-${
                    previousMonthLastMondayDayOfMonth + index
                }`
            ).format("YYYY-MM-DD"),
            dayOfMonth: previousMonthLastMondayDayOfMonth + index,
            isCurrentMonth: false
        };
    });
}

const createDaysForNextMonth = (year, month) => {
    let lastDayOfTheMonthWeekday = getWeekDay(`${year}-${month}-${currentMonthDays.length}`);
    const nextMonth = dayjs(`${year}-${month}-01`).add(1, "month");

    const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday ? 7 - lastDayOfTheMonthWeekday : 7 - lastDayOfTheMonthWeekday;

    return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
            ).format("YYYY-MM-DD"),
            dayOfMonth: index + 1,
            isCurrentMonth: false
        };
    });
}

const appendDay = (day, calendarDaysElements, minimalBookingDate) => {
    let dayData = [];
    QUICK_RELEASE_DATA.forEach((data) => {
        if (data.flightDate === day.date) {
            dayData.push(data);
        }
    });
    const dayElement = document.createElement("li");
    const dayElementClassList = dayElement.classList;
    dayElementClassList.add("calendar-day");
    const dayOfMonthElement = document.createElement("span");
    dayOfMonthElement.innerText = day.dayOfMonth;
    dayElement.appendChild(dayOfMonthElement);
    calendarDaysElements.appendChild(dayElement);

    OFF_SEASON_SLOTS.forEach((slot) => {
        if (dayjs(day.date).isBetween(slot.startDate, slot.endDate, 'day', '[]')) {
            dayElementClassList.add("calendar-day--off-season");
        }
    });

    if (!dayElementClassList.contains("calendar-day--off-season")) {
        if (!day.isCurrentMonth) {
            dayElementClassList.add("calendar-day--not-current");
        } else if (dayjs(day.date).isBefore(TODAY)) {
            dayElementClassList.add("calendar-day--past");
        } else if (day.date === TODAY) {
            dayElementClassList.add("calendar-day--today");
        } else if (dayData.length) {
            let isAvailable = false;

            const regionsContainer = document.createElement('div');
            regionsContainer.classList.add('region-container');

            dayElement.appendChild(regionsContainer);

            const numberOfPassengers = parseInt(document.getElementById('booking-form-numberOfPassengers').value);

            dayData.forEach((data) => {
                const flightDate = dayjs(data.flightDate + ' ' + data.flightHour, 'YYYY-MM-DD HH:mm');
                if (flightDate.isAfter(minimalBookingDate) && data.freeCapacity - data.toConfirmPassengers >= numberOfPassengers) {
                    appendRegionToDay(regionsContainer, data);
                    isAvailable = true;
                    return false;
                }
            });

            if (isAvailable) {
                dayElementClassList.add("calendar-day--available");
                dayElement.addEventListener('click', function () {
                    showAvailableSlots(dayData, minimalBookingDate);
                });
            }
        }
    }
}

const appendRegionToDay = (regionsContainer, data) => {
    if (!regionsContainer.querySelector('.region-' + AREAS[data.region])) {
        const flightHour = parseInt(data.flightHour.split(':')[0]);
        let flightType = 'VS';
        if (flightHour < 15) {
            flightType = 'VM'
        }

        const regionElement = document.createElement('div');
        regionElement.innerHTML = flightType;
        regionElement.classList.add('region-item');
        regionElement.classList.add('region-' + flightType);

        regionsContainer.appendChild(regionElement);
    }
}

const showAvailableSlots = (dayData, minimalBookingDate) => {
    const slotsWrapperElement = CALENDAR_ELEMENT.querySelector('#slots-wrapper');
    while (slotsWrapperElement.firstChild) {
        slotsWrapperElement.removeChild(slotsWrapperElement.firstChild);
    }

    const slotsSelectedDateElement = CALENDAR_ELEMENT.querySelector('#slots-selected-date');
    slotsSelectedDateElement.innerHTML = '<span>' + dayjs(dayData[0].flightDate).format('DD MMMM YYYY') + '</span>';

    NUMBER_OF_PASSENGERS = document.getElementById('booking-form-numberOfPassengers').value;

    dayData.forEach((data) => {
        const flightDate = dayjs(data.flightDate + ' ' + data.flightHour, 'YYYY-MM-DD HH:mm');
        if (flightDate.isAfter(minimalBookingDate) && data.freeCapacity - data.toConfirmPassengers >= NUMBER_OF_PASSENGERS) {
            const slotElement = document.createElement('div');
            const remainingPlaceString = (data.freeCapacity - data.toConfirmPassengers) > 1 ? (data.freeCapacity - data.toConfirmPassengers) + ' ' + translations.SLOTS.remainingPlaces : (data.freeCapacity - data.toConfirmPassengers) + ' ' + translations.SLOTS.remainingPlace;

            const flightHour = parseInt(data.flightHour.split(':')[0]);
            let flightType = '';
            let flightTypeTranslation = '';

            if (flightHour < 15) {
                flightTypeTranslation = translations.SLOTS.flightType.mountainFlight + ' (' + translations.SLOTS.flightType.mountainFlightDescription + ')';
                flightType = 'mountainFlight';
            } else {
                flightTypeTranslation = translations.SLOTS.flightType.lowlandFlight + ' (' + translations.SLOTS.flightType.lowlandFlightDescription + ')';
                flightType = 'lowlandFlight';
            }

            slotElement.classList.add('slot-item');
            slotElement.innerHTML = `
                <div class="location">` + data.regionName + `</div>
                <div class="flight-hour">` + data.flightHour + `</div>
                <div class="flight-type">` + flightTypeTranslation + `</div>
                <div class="slot-free-capacity">` + remainingPlaceString + `</div>
            `;

            const slotBookingButtonWrapper = document.createElement('div');
            slotBookingButtonWrapper.classList.add('slot-booking-button-wrapper');

            const slotBookingButton = document.createElement('div');
            slotBookingButton.classList.add('btn');
            slotBookingButton.classList.add('btn-primary');
            slotBookingButton.innerHTML = translations.SLOTS.book;
            slotBookingButton.addEventListener('click', () => {
                selectSlot(data, flightType);
            });
            slotBookingButtonWrapper.appendChild(slotBookingButton);
            slotElement.appendChild(slotBookingButtonWrapper);
            slotsWrapperElement.appendChild(slotElement);
        }
    });

    document.getElementById('calendar-available-slots').classList.add('visible');
}

const selectSlot = (data, flightType) => {
    const flightDateInput = document.getElementById('booking-form-flightDate');
    const flightHourInput = document.getElementById('booking-form-flightHour');
    const flightTypeInput = document.getElementById('booking-form-flightType');
    const flightDataInput = document.getElementById('booking-form-flightData');

    flightDateInput.value = dayjs(data.flightDate).format('DD MMMM YYYY');
    flightHourInput.value = data.flightHour;
    flightTypeInput.value = flightType === 'mountainFlight' ? translations.SLOTS.flightType.mountainFlight : translations.SLOTS.flightType.lowlandFlight;
    flightDataInput.value = JSON.stringify(data);

    if (constants.existingReservation) {
        bookingForm.updatePassengersInformationsField(constants.reservation.numberOfPassengers * 3);
    }

    bookingBasket.mountBookingBasketIfNeeded();

    orderSummary.updateOrderSummaryTable(data.region, flightType);

    const numberOfPassengers = constants.existingReservation ? constants.reservation.numberOfPassengers : document.getElementById('booking-form-numberOfPassengers').value;
    const maximumPassengers = parseInt(document.getElementById('maximum-passengers').dataset.maximumPassengers);
    const freeCapacity = data.freeCapacity - data.toConfirmPassengers;

    if (numberOfPassengers < maximumPassengers && numberOfPassengers < freeCapacity) {
        bookingForm.createAddPassengerButton();
    } else {
        bookingForm.removeAddPassengerButton();
    }

    const bookingFormElement = document.querySelector('.tc-website-bookingform');
    if (!bookingFormElement.classList.contains('visible')) {
        if (constants.existingReservation) {
            bookingForm.fillSubscriberInformation();
        }

        bookingForm.updatePassengersInformationsField(3 * numberOfPassengers);
        bookingFormElement.classList.add('visible');
    }

    document.getElementById('calendar-available-slots').classList.remove('visible');
    const orderSummaryAlert = document.querySelector('.order-summary-alert');
    const orderSummaryTable = document.querySelector('.order-summary-table');
    if (orderSummaryAlert) {
        orderSummaryAlert.classList.remove('visible');
    }
    if (orderSummaryTable) {
        orderSummaryTable.classList.remove('hidden');
    }
    bookingFormElement.scrollIntoView();
}

const initMonthSelectors = () => {
    CALENDAR_ELEMENT
        .querySelector('#previous-month-selector')
        .addEventListener("click", function () {
            selectedMonth = dayjs(selectedMonth).subtract(1, "month");
            updateCalendar(selectedMonth.format("YYYY"), selectedMonth.format("M"));
            CALENDAR_ELEMENT.dataset.currentMonth = selectedMonth.format("M");
            CALENDAR_ELEMENT.dataset.currentYear = selectedMonth.format('YYYY');
        });

    CALENDAR_ELEMENT
        .querySelector('#present-month-selector')
        .addEventListener("click", function () {
            selectedMonth = dayjs(new Date(INITIAL_YEAR, INITIAL_MONTH - 1, 1));
            updateCalendar(selectedMonth.format("YYYY"), selectedMonth.format("M"));
            CALENDAR_ELEMENT.dataset.currentMonth = selectedMonth.format("M");
            CALENDAR_ELEMENT.dataset.currentYear = selectedMonth.format('YYYY');
        });

    CALENDAR_ELEMENT
        .querySelector('#next-month-selector')
        .addEventListener("click", function () {
            selectedMonth = dayjs(selectedMonth).add(1, "month");
            updateCalendar(selectedMonth.format("YYYY"), selectedMonth.format("M"));
            CALENDAR_ELEMENT.dataset.currentMonth = selectedMonth.format("M");
            CALENDAR_ELEMENT.dataset.currentYear = selectedMonth.format('YYYY');
        });
}

const initSlotsModalClose = () => {
    document
        .getElementById('close-available-slots')
        .addEventListener("click", function () {
            document.getElementById("calendar-available-slots").classList.remove("visible");
        });
}

const getNumberOfDaysInMonth = (year, month) => {
    return dayjs(`${year}-${month}-01`).daysInMonth();
}

const getWeekDay = (date) => {
    const jsDay = dayjs(date).day();
    return (jsDay + 6) % 7;
}

const removeAllDaysElements = (calendarDaysElements) => {
    let first = calendarDaysElements.firstElementChild;

    while (first) {
        first.remove();
        first = calendarDaysElements.firstElementChild;
    }
}

const updateNumberOfPassengers = (numberOfPassengers) => {
    NUMBER_OF_PASSENGERS = numberOfPassengers;
}

module.exports = {updateQuickReleaseData, buildCalendar, updateCalendar, initMonthSelectors, updateNumberOfPassengers, selectedMonth}
